// Remove &#039; from string and replace with '
export const removeMark = (str: string) => {
  return str.replace(/&#039;/g, "'");
};
